module.exports = __webpack_public_path__ + "img/H.d24ced3d.png";